import { render, staticRenderFns } from "./NeoparentNewParent.vue?vue&type=template&id=31c9adbc&scoped=true"
import script from "./NeoparentNewParent.vue?vue&type=script&lang=js"
export * from "./NeoparentNewParent.vue?vue&type=script&lang=js"
import style0 from "./NeoparentNewParent.vue?vue&type=style&index=0&id=31c9adbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c9adbc",
  null
  
)

export default component.exports